import { scrollTo } from './browser';
import css from '@wix/da-ds/src/styles/variables.scss';
const siteHeaderHeight = parseInt(css['site-header-height']);
const siteHeaderHeightMobile = parseInt(css['site-header-height-mobile']);
function scrollElementToViewPortOffset(element, offset, scrollableAncestor, smoothScroll) {
    if (typeof window === 'undefined') {
        return;
    }
    const bounds = element.getBoundingClientRect();
    const ancestorOffset = scrollableAncestor ? scrollableAncestor.scrollTop : window.pageYOffset;
    const newY = Math.max(ancestorOffset - offset + bounds.top, 0);
    const options = {
        left: 0,
        top: newY,
        behavior: 'auto'
    };
    if (smoothScroll) {
        options.behavior = 'smooth';
    }
    scrollableAncestor ? scrollTo(scrollableAncestor, options) : scrollTo(window, options);
}
// we are conveniently assuming there's only vertical scrolling in here
export function scrollIntoViewWithHeader(element, isMobile = false, extraHeaderHeight = 0, scrollableAncestor, smoothScroll, skipVisibilityCheck) {
    if (typeof window === 'undefined') {
        return;
    }
    const headerHeight = (isMobile ? siteHeaderHeightMobile : siteHeaderHeight) + extraHeaderHeight;
    const bounds = element.getBoundingClientRect();
    // if it's already visible, nothing to do
    if (bounds.top >= headerHeight && bounds.bottom <= window.innerHeight && !skipVisibilityCheck) {
        return;
    }
    scrollElementToViewPortOffset(element, headerHeight, scrollableAncestor, smoothScroll);
}
// in cases when sticky stuff is just too much PITA, assume mid point is somewhat acceptable
export function scrollIntoViewInViewportCenter(element, isMobile = false, scrollableAncestor, smoothScroll) {
    if (typeof window === 'undefined') {
        return;
    }
    const viewPortHeight = window.innerHeight - (isMobile ? siteHeaderHeightMobile : siteHeaderHeight);
    const bounds = element.getBoundingClientRect();
    scrollElementToViewPortOffset(element, (viewPortHeight - bounds.height) / 2, scrollableAncestor, smoothScroll);
}
export function scrollIntoViewInViewportBottom(element, isMobile = false, offsetFromBottom = 0, scrollableAncestor, smoothScroll) {
    if (typeof window === 'undefined') {
        return;
    }
    const viewPortHeight = window.innerHeight - (isMobile ? siteHeaderHeightMobile : siteHeaderHeight);
    const bounds = element.getBoundingClientRect();
    scrollElementToViewPortOffset(element, viewPortHeight - bounds.height - offsetFromBottom, scrollableAncestor, smoothScroll);
}
